import {
  DateTimeFilter,
  MultiSelectFilter,
} from "../../../../../dataGrid/columnFilters";
import appConstants from "../../../../../../appConstants";
import CheckboxRenderer from "../../../components/CheckboxRenderer";
import { IBETARenderer } from "../../../../../dataGrid/cellRenderer";
import { format } from "date-fns";
import { checkInPlanShipmentsExistInBatch } from "../../utils";

export default class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.name = "GridConfiguration";
    this.config = GridConfig.getConfiguration(config);
  }
  static getConfiguration({ terminal }) {
    return GridConfig.getDefaultConfiguration({ terminal });
  }

  static isFirstColumn(params) {
    const displayedColumns = params.columnApi.getAllDisplayedColumns();
    return displayedColumns[0] === params.column;
  }

  static checkboxValueGetter(params) {
    return {
      checked: params.data.isSelected,
      isIntermediate: params.data.isIntermediate,
      disabled: checkInPlanShipmentsExistInBatch(
        params.data.shipmentsForDestTerminal
      ),
    };
  }

  static formatDateTime(params) {
    return params.value ? format(params.value, appConstants.DATETYPES.DATETIME.format) : "";
  }

  static getCurrentLocation(params) {
    if (params.data.status === "ENR") {
      return "";
    }
    return params.data.currentTerminal;
  }

  static getNextLocation(params) {
    if (params.data.status === "ENR") {
      return params.data.nextTerminal;
    }
    return "";
  }

  static getDispatchFrom(params) {
    if (params.data.status === "ENR") {
      return params.data.currentTerminal;
    }
    return "";
  }

  static getTrailerIBETA(params) {
    if (params.data.status === "ENR") {
      return params.data.trailerIbeta;
    }
    return "";
  }

  static getDefaultConfiguration({ terminal }) {
    return {
      title: appConstants.gridNames.ReturnsGrid,
      keyColumn: "id",
      rowSelection: "multiple",
      rowDeselection: true,
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      rowClassRules: {
        "ag-row-selected": (params) => params.data.isSelected,
        "ag-row-disabled": (params) =>
          checkInPlanShipmentsExistInBatch(
            params.data.shipmentsForDestTerminal
          ),
      },
      columns: [
        {
          headerName: "",
          valueGetter: GridConfig.checkboxValueGetter,
          colId: "batchCheckbox",
          cellRendererFramework: CheckboxRenderer,
          minWidth: appConstants.columnWidth.W_62,
          maxWidth: appConstants.columnWidth.W_62,
          cellClassRules: {
            "gridCell-centerAlign": true,
            disabledCheckboxIBBills: (params) =>
              checkInPlanShipmentsExistInBatch(
                params.data.shipmentsForDestTerminal
              ),
          },
        },
        {
          headerName: "Trailer Scac",
          field: "trailerScac",
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_120,
        },
        {
          headerName: "Trailer #",
          field: "trailerNumber",
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_100,
        },
        {
          headerName: "Manifest",
          field: "manifestNumber",
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_110,
        },
        {
          headerName: "Current Status",
          headerTooltip: "Current Status",
          field: "status",
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_140,
        },
        {
          headerName: "Curr Loc",
          headerTooltip: "Current Location",
          field: "currentTerminal",
          valueGetter: GridConfig.getCurrentLocation,
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_110,
        },
        {
          headerName: "Next Loc",
          headerTooltip: "Next Location",
          field: "nextTerminal",
          valueGetter: GridConfig.getNextLocation,
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_110,
        },
        {
          headerName: "Trailer Dest",
          headerTooltip: "Trailer Destination",
          field: "destTerminal",
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_110,
        },
        {
          headerName: "Trlr ETA",
          headerTooltip: "Trailer ETA",
          field: "trailerIbeta",
          minWidth: appConstants.columnWidth.IBETA,
          valueGetter: GridConfig.getTrailerIBETA,
          valueFormatter: GridConfig.formatDateTime,
          filterFramework: DateTimeFilter,
          filterParams: {
            DATETYPE: appConstants.DATETYPES.DATETIME,
          },
        },
        {
          headerName: `${terminal} Bills`,
          field: "shipmentsForDestTerminalCount",
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_120,
        },
        {
          headerName: `Ttl Trlr Bills`,
          headerTooltip: "Total Trailer Bills",
          field: "shipmentsInTrailerCount",
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_120,
        },
        {
          headerName: "IB ETA",
          headerTooltip: "IB ETA",
          field: "maxIBETA",
          minWidth: appConstants.columnWidth.IBETA,
          valueFormatter: GridConfig.formatDateTime,
          cellRendererFramework: IBETARenderer,
          filterFramework: DateTimeFilter,
          filterParams: {
            DATETYPE: appConstants.DATETYPES.DATETIME,
          },
        },
        {
          headerName: "SVC",
          headerTooltip: "SVC",
          field: "priorityBillsCount",
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_110,
        },
        {
          headerName: `${terminal} Bills Due Today`,
          field: "shipmentsDueOnPlanDateCount",
          filterFramework: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_170,
          cellClass: "dueBillsCell",
          colId: "totalBills",
        },
        {
          headerName: "Orig Term",
          headerTooltip: "Origin Terminal",
          field: "originTerminal",
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_110,
        },
        {
          headerName: "Dispatch From",
          headerTooltip: "Origin Terminal",
          field: "originTerminal",
          valueGetter: GridConfig.getDispatchFrom,
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_110,
        },
        {
          headerName: "Ttl Trlr HU",
          headerTooltip: "Total Trailer HU",
          field: "totalTrailerHu",
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_140,
        },
        {
          headerName: "Ttl Trlr Wgt",
          headerTooltip : "Total Trailer Weight",
          field: "totalTrailerWeight",
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_140,
        },
      ],
    };
  }
}
